import React from "react";

const FormGroup = ({ 
    children, 
    direction = 'horizontal',
    labelWidth,
    inputWidth,
    groupWidth,
    className
}) => {
    const baseStyles = `flex ${direction === 'horizontal' ? 'flex-row items-start' : 'flex-col'} mb-[16px]`;
    const labelStyles = labelWidth ? labelWidth : '';
    const inputStyles = inputWidth ? inputWidth : '';
    const groupStyles = groupWidth ? groupWidth : '';
    return (
        <div className={`${baseStyles} ${groupStyles} ${className || ''}`}>
            {React.Children.map(children, child => {
                let childClassName = child.props.className || '';
                // Process for label
                if (labelWidth && child.type.name === 'Label') {
                    childClassName = `${labelStyles} ${childClassName} mt-[5px]`;
                }
                if (direction === 'vertical' && child.type.name === 'Label') {
                    childClassName = `${labelStyles} ${childClassName}`;
                }
            
                if (inputWidth && child.type.name === 'FormGroupInput') {
                    childClassName = `${childClassName} ${direction === 'horizontal' ? 'flex-col' : ''} ${inputStyles}`;
                }

                if (direction === 'vertical' && child.type.name === 'FormGroupInput') {
                    childClassName = `${childClassName} flex-col`;
                }

                return React.cloneElement(child, {
                    className: childClassName
                });
            })}
        
        </div>
    );
};

export default FormGroup;